import { Certificate } from "@/services/backend/vbs/certificates/types/certificate";
import {
  updateVbsCertificateCache,
  useVbsCertificateResetReferenceNumberMutation,
  useVbsCertificatePatchMutation,
} from "@/services/backend/vbs/certificates/api/certificate-api";
import { ReferenceNumberField } from "@/services/backend/documents/components/reference-number-field";
import { isImmutable } from "@/services/backend/documents/lib/document-state";

/**
 * CertificateReferenceNumberField edits the reference number of a certificate.
 */
export function CertificateReferenceNumberField({
  certificate,
  disabled = false,
}: {
  certificate: Certificate;
  disabled?: boolean;
}) {
  const patchReferenceNumber = useVbsCertificatePatchMutation();
  const resetReferenceNumber = useVbsCertificateResetReferenceNumberMutation();

  return (
    <ReferenceNumberField
      data={certificate}
      updateCache={updateVbsCertificateCache}
      patchMutation={patchReferenceNumber}
      resetMutation={resetReferenceNumber}
      disabled={disabled || isImmutable(certificate)}
    />
  );
}
